var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49559 11.2455C8.64919 11.0919 8.74328 10.8784 8.74298 10.644L8.74298 10.5408C8.74298 10.0714 8.36294 9.69134 7.89409 9.69194L3.25567 9.69194L11.1021 1.84555C11.4334 1.51417 11.4334 0.976283 11.1021 0.644906C10.7707 0.313529 10.2328 0.313529 9.90142 0.644906L2.05503 8.49129L2.05503 3.85287C2.05503 3.38342 1.67499 3.00338 1.20614 3.00398H1.10296C0.633505 3.00398 0.253464 3.38402 0.254064 3.85287V10.644C0.254064 11.1135 0.634105 11.4935 1.10296 11.4929L7.89409 11.4929C8.12882 11.4929 8.34198 11.3991 8.49559 11.2455Z",
    fill: "#EE4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/red-arrow.aceba39cbf4f6118de6863e4967b2f93.svg";
export { ForwardRef as ReactComponent };